import React from "react"

const Section3: React.FC = () => {
  return (
    <div
      className={`w-[50%] h-full bg-center bg-contain relative overflow-hidden bg-[#f6f1eb]/50`}
    >
      <div className="w-full h-full">
        <div className="h-[45%] w-full flex flex-row">
          <div className="relative items-center bg-[#799177] w-[380px] h-[350px] rounded-br-[600px]">
            <div className="relative w-[350px] h-[310px]">
              <div className="absolute bg-[#164229] right-[-10%] bottom-[10%] w-[200px] h-[200px] rounded-full items-center justify-center flex flex-col">
                <p className="font-playfair font-semibold text-4xl text-white">
                  TRÀ
                </p>
                <p className="font-playfair font-semibold text-4xl text-white">
                  ĐEN
                </p>
              </div>
              <img
                className="w-full h-full rounded-br-[600px] object-cover"
                src="./banners/banner5.png"
              />
            </div>
          </div>
          <div className=" flex-1 relative h-full flex px-[30px] flex-col">
            <p className="font-playfair font-bold text-[#092b16] text-[16px]">
              Thành phần
            </p>
            <p className="text-[#092b16] text-[13px] text-justify flex-wrap">
              Trà xanh lên men 100%
            </p>
            <p className="font-playfair font-bold text-[#092b16] text-[16px]">
              Hương vị
            </p>
            <p className="text-[#092b16] text-[13px] text-justify flex-wrap">
              Trà đen là sự hòa quyện giữa vị đậm đà, trọn vẹn của lá trà lên
              men và hương thơm nồng ấm, đôi khi phảng phất chút mật ong hoặc
              gỗ. Khi thưởng thức, vị chát xuất hiện đầu tiên, sau đó nhanh
              chóng nhường chỗ cho hậu ngọt dịu, tạo cảm giác cân bằng và dễ
              chịu. Chính sự đậm đà cùng hương thơm tinh tế này mang lại trải
              nghiệm vừa quen thuộc, vừa hoài cổ, khiến trà đen trở thành lựa
              chọn hoàn hảo để nhâm nhi riêng hoặc kết hợp pha chế đa dạng.
            </p>
            <p className="font-playfair font-bold text-[#092b16] text-[16px]">
              Thành phần
            </p>
            <p className="text-[#092b16] text-[13px] text-justify flex-wrap">
              "Mùi mật ong" hay "gỗ" của trà đen là tầng hương tự nhiên được
              sinh ra trong quá trình chế biến.
            </p>
          </div>
        </div>
        <div className="flex-1 h-[55%] w-full flex flex-col">
          <div className="w-[55%] ml-[5%]">
            <div className="flex-row gap-2 items-center flex">
              <h1 className="font-playfair text-[#092b16] text-[32px]">
                Chi tiết mùi vị
              </h1>
              <img
                className="w-[40px] h-[40px] object-contain"
                src="./logos/leaf-default.png"
              />
            </div>
            <p className="font-playfair font-bold text-[#092b16] text-[16px]">
              Hương thơm
            </p>
            <p className="text-[#092b16] text-[13px] text-justify flex-wrap">
              Trà đen mang trong mình hương thơm nồng ấm và dày dặn, dễ dàng
              chinh phục khứu giác ngay từ lần đầu tiếp xúc. Ẩn trong tầng hương
              ấy là những nốt hương tinh tế, đôi khi phảng phất chút mật ong
              ngọt ngào hay thoảng mùi gỗ ấm áp, tạo nên sự gần gũi nhưng cũng
              đầy chiều sâu.
            </p>
          </div>
          <div className="flex-1 bg-[#092b16] flex flex-row ">
            <div className="w-[50%] h-full px-[15px] pt-[10px]">
              <p className="font-playfair font-bold text-white text-[16px]">
                Mùi vị
              </p>
              <p className="text-white text-[12px] text-justify flex-wrap">
                Khi thưởng thức, vị chát đặc trưng của trà đen xuất hiện đầu
                tiên, đủ rõ để đánh thức vị giác nhưng không quá gắt. Ngay sau
                đó, vị trà nhanh chóng trở nên tròn đầy, đậm đà sự hòa quyền tự
                nhiên từ quá trình lên men, rồi dần được làm dịu bởi hậu vị ngọt
                dịu lan tỏa trên vòm miệng, mang đến sự cân bằng tinh tế.
              </p>
              <p className="font-playfair font-bold text-white text-[16px]">
                Mùi vị
              </p>
              <p className="text-white text-[12px] text-justify flex-wrap">
                Điểm nhấn đặc biệt của trà đen chính là hậu vị ngọt thanh và ấm
                áp, kéo dài sau khi uống. Cảm giác này gợi nên sự hoài cổ, vừa
                quen thuộc vừa an yên, khiến người thưởng thức dễ dàng đắm chìm.
                Chính nhờ hậu vị đặc sắc đó mà trà đen không chỉ phù hợp để nhâm
                nhi riêng, mà còn trở thành nền tảng lý tưởng cho nhiều công
                thức pha chế phong phú.
              </p>
            </div>
            <div className="w-[50%] flex justify-center h-full relative bottom-0">
              <img
                className="w-[300px] bottom-0 absolute h-[150px] rounded-t-[600px] object-cover"
                src="./banners/banner7.png"
              />
              <img
                className="w-[200px] h-[200px] mt-[-100px] right-[30px] rounded-full absolute object-cover"
                src="./banners/banner6.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section3
